import * as React from "react";
const SVGComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11.28}
    height={8.46}
    viewBox="0 0 11.28 8.46"
    role="img"
    {...props}
  >
    <g id="noun-users-2120769" transform="translate(-0.001 -150)">
      <path
        id="Path_197"
        data-name="Path 197"
        d="M752.82,251.41a1.41,1.41,0,1,1-1.41-1.41,1.41,1.41,0,0,1,1.41,1.41"
        transform="translate(-742.949 -99.06)"
        fill="#00446e"
      />
      <path
        id="Path_198"
        data-name="Path 198"
        d="M699.891,625h-.235a2.575,2.575,0,0,0-1.9.834,3.749,3.749,0,0,1,.726,2.221v.235h3.995v-.705A2.584,2.584,0,0,0,699.891,625Z"
        transform="translate(-691.195 -470.535)"
        fill="#00446e"
      />
      <path
        id="Path_199"
        data-name="Path 199"
        d="M153.76,151.88a1.88,1.88,0,1,1-1.88-1.88,1.88,1.88,0,0,1,1.88,1.88"
        transform="translate(-148.589)"
        fill="#00446e"
      />
      <path
        id="Path_200"
        data-name="Path 200"
        d="M3.526,625h-.47A3.055,3.055,0,0,0,0,628.051v.94h6.58v-.94A3.056,3.056,0,0,0,3.526,625Z"
        transform="translate(0 -470.531)"
        fill="#00446e"
      />
    </g>
  </svg>
);
export default SVGComponent;
